// Story 7.32 (ADO-1115) and Story 7.29 (ADO-2025): which Trading Account a catalogue read names.
//
// Where Featured Lines are resolved (the collected-offers union, the `FEATURED_LINE` filter) a
// store user's read names the account its cart and its card prices use, since a Featured Line is
// priced for it; elsewhere it names the active account the narrowing gates read (D-7.29-21), the
// same account for a store user. Staff name none anywhere (TL decision 2026-10-29, D-7.29-23):
// they cannot be priced, and an account would only withhold narrowings from them. The listing and
// the search share this one rule (PR #862 review), so search within the Featured Lines prices them
// for the account the listing does.

import type { ProductFilters } from '../api/facets';
import { useSessionCartTarget } from '../basket/sessionCart';
import { useCatalogueAccountCode, useIsStaffSession } from './catalogueEntry';

/** The server offer kind of a Featured Line (`OfferKindDto.FEATURED_LINE`). */
const FEATURED_LINE_KIND = 'FEATURED_LINE';

/** Whether a read resolves the caller's Featured Lines: the collected-offers union, or the
 *  `FEATURED_LINE` filter. Lock-step with the API's `featuredFor`. */
export function resolvesFeaturedLines(collectedOffers: boolean, filters: ProductFilters): boolean {
  return collectedOffers || filters.offerType?.includes(FEATURED_LINE_KIND) === true;
}

/** The account a catalogue read names, from the session facts (see the header). */
export function catalogueReadAccountCode(session: {
  readonly resolvesFeaturedLines: boolean;
  readonly staffSession: boolean;
  readonly cartAccountCode: string | null;
  readonly activeAccountCode: string | null;
}): string | null {
  return session.resolvesFeaturedLines && !session.staffSession
    ? session.cartAccountCode
    : session.activeAccountCode;
}

/** {@link catalogueReadAccountCode} as a SUBSCRIBED value. */
export function useCatalogueReadAccountCode(featuredLinesResolved: boolean): string | null {
  const activeAccountCode = useCatalogueAccountCode();
  const cartAccountCode = useSessionCartTarget()?.customerAccountCode ?? null;
  const staffSession = useIsStaffSession();
  return catalogueReadAccountCode({
    resolvesFeaturedLines: featuredLinesResolved,
    staffSession,
    cartAccountCode,
    activeAccountCode,
  });
}
